import { ListItemIcon } from '@mui/material';
import ErrorIcon from '../../icons/ErrorIcon';
import GoogleDriveIcon from '../../icons/GoogleDriveIcon';
import OneDriveIcon from '../../icons/OneDriveIcon';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';

type UploadMenuItemIconProps = {
  variant: 'google_drive' | 'onedrive';
  uploading: boolean;
  hasError: boolean;
};

const UploadMenuItemIcon = ({
  variant,
  uploading,
  hasError,
}: UploadMenuItemIconProps) => (
  <ListItemIcon>
    {uploading ? (
      <MenuItemLoadingIndicator />
    ) : hasError ? (
      <ErrorIcon />
    ) : variant === 'onedrive' ? (
      <OneDriveIcon />
    ) : (
      <GoogleDriveIcon />
    )}
  </ListItemIcon>
);

export default UploadMenuItemIcon;
